import AppTag from './AppTag';

interface AdminFormLabelProps {
  label: string;
  required?: boolean;
  className?: string;
}

const AdminFormLabel = ({ label, required, className }: AdminFormLabelProps) => {
  return (
    <div className={`flex items-center gap-2 ${className || 'mb-2'}`}>
      <p className="text-sm font-normal">{label}</p>
      {/* <label className="text-sm font-normal">{label}</label> */}
      {required && <AppTag color="magenta">必須</AppTag>}
    </div>
  );
};

export default AdminFormLabel;
